import geographySelector from './states';
import worldSelector from './world';

export default {
  state: geographySelector,
  world: worldSelector,
};



// WEBPACK FOOTER //
// ./app/selectors/indicator/maps/index.js